import { render } from "./KPIPeriodsModal.vue?vue&type=template&id=87b4d152&scoped=true"
import script from "./KPIPeriodsModal.vue?vue&type=script&lang=js"
export * from "./KPIPeriodsModal.vue?vue&type=script&lang=js"

import "./KPIPeriodsModal.vue?vue&type=style&index=0&id=87b4d152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b4d152"]])

export default __exports__